import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../types";

const initialState: RootState["eventEdition"] = {
  eventSecret: "",
  eventEdition: null,
  badges: [],
  orders: [],
  badgeLocation: "",
  cmsEventDetails: null
};

const eventEditionSlice = createSlice({
  name: "eventEdition",
  initialState,
  reducers: {
    setEventEdition(state, action) {
      state.eventEdition = action.payload;
    },
    setEventEditionSecret(state, action) {
      state.eventSecret = action.payload;
    },
    setBadgeLocation(state, action) {
      state.badgeLocation = action.payload;
    },
    setBadgeOrders(state, action) {
      state.orders = action.payload;
    },
    setCmsEventDetails(state, action) {
      state.cmsEventDetails = action.payload;
    },
    setEventEditionBadges(state, action) {
      state.badges = action.payload;
    },
    resetEventEditionReducer() {
      return initialState;
    }
  }
});

export const {
  setEventEdition,
  resetEventEditionReducer,
  setEventEditionBadges,
  setEventEditionSecret,
  setBadgeLocation,
  setBadgeOrders,
  setCmsEventDetails
} = eventEditionSlice.actions;

export default eventEditionSlice.reducer;